import { Link } from "react-router-dom"

export const Announcement = () => { 
  return (
    <div className="disclaimer-container">
      <h1 className="disclaimer-title">Welcome to DEEPVIN<span class="fs-4" style={{verticalAlign: 'top' }}>&#8482;</span></h1>
      <h4 style={{ textAlign: 'center' }}>A Video Cloud for EMS</h4>
      <hr />

      <h2 className="disclaimer-subtitle">July 2026 Announcement</h2>
      <p><strong>UE Transfer App 2.0 is now available in Apple App store!</strong></p>
      <p><strong>This new version inlcudes major UI overhauls and underlying process improvements! The download and upload performance has been significantly enhanced, especially for files uploading. </strong></p> 
      <hr />

      <h2 className="disclaimer-subtitle">Announcement</h2>
      <p><strong>Starting on June 16 2025, DeepVin will enforce Retention period for videos!</strong></p>
      <p><strong>Please make sure Retention Days is set properly in Account Policy under Admin Settings. Once Retention period passes, the videos will be removed from cloud storage!</strong></p> 
      <hr />

      <h2 className="disclaimer-subtitle">New Features</h2>

      <p>The following new features are available on deepvin.com with latest updates.</p>

      <ol className="disclaimer-list">
        <li>
          <strong>VideoTime and CaseID in Reports CSV (Mar 2026):</strong> Exported reports CSV now includes VideoTime and optional CaseID fields.
        </li>
        <li>
          <strong>Export Case Report in PDF (Jan 2026):</strong> Admin users can export individual case reports in PDF format.
        </li>
        <li>
          <strong>Case Reviewer (Dec 2025):</strong> Admin users can mark themselves as reviewers to a case.
        </li>
        <li>
          <strong>Archive Case (Dec 2025):</strong> A Case can now be archived from the Report Card page.
        </li>
        <li>
          <strong>Case Labels (Nov 2025):</strong> Cases can now be tagged with multiple labels (managed by admins) for better organization and searchability.
        </li>
        <li>
          <strong>Required and FromProvider template fields (Sept 2025):</strong> Required fields have * next to them and can not be empty; FromProvider fields allow for user input on UE-Transfer app during upload.
        </li>
        <li>
          <strong>Export Data as CSV (July 1st 2025):</strong> Case reports and Attempt reports data can now be exported as csv file from Reports page.
        </li>
        <li>
          <strong>Cases:</strong> The new Cases page offers agencies capability to organize video cases by folders. Admin users can create folders and move cases among folders.
        </li>
        <li>
          <strong>Sharing videos within team:</strong> This gives Admin users ability to allow a team to share within the team itself videos that are assigned to its members.
        </li>
        <li>
          <strong>Field relations:</strong> Limited set of conditions or relations can be set between template fields to enhance data integrity.
        </li>
        <li>
          <strong>Reports plot by provider:</strong> Plots by providers is added on Reports page.
        </li>
      </ol>

      <hr />
      <p>Please see the <Link to={`/tutorial`} class="fw-bold">Tutorial</Link> for details of these new features.</p>
      <p>For any questions or concerns, please contact us at <span className="contact-info">info@deepvin.com</span></p>
      <p>Thank you for using <span className="website-name">DeepVin.com</span></p>
    </div>
  )
}